<div class="body-alert">
    <div class="div-alert text-center">
      <img class="mt-4" src="/assets/img/success.png" width="82px" alt="Sucesso">
      <p class="titulo-alert">Aprovação realizada!</p>
      <p class="subtitulo-alert">Rota Inteligente aprovada com sucesso.</p>
      <div class="footer-alert">
        <button class="botao" (click)="fecharAlertSucessoAprovacao()">FECHAR</button>
      </div>
    </div>
  </div>
  